<template>
  <p class="mt-2 text-sm text-neutral-40">
    <slot></slot>
  </p>
</template>

<script>
export default {
  name: "InputHint",
};
</script>
